import { Modal } from 'antd';
import styled from 'styled-components';
import { media } from 'settings/style';

export const BASE_MODAL_TEXT_SECONDARY = '#4b5563';

/**
 * Shared auth-style modal shell.
 * Use this for dialogs that should match sign-in/sign-up visual style.
 */
const BaseModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18);
  }

  .ant-modal-header {
    display: none;
  }

  .ant-modal-body {
    padding: 40px 40px 36px;
    background: #ffffff;

    ${media.md`
      padding: 28px 20px 24px;
    `}
  }

  .ant-modal-close {
    top: 10px;
    inset-inline-end: 16px;
    color: #000000;

    .ant-modal-close-x {
      color: #000000;
    }

    &:hover {
      color: #000000;

      .ant-modal-close-x {
        color: #000000;
      }
    }
  }
`;

export default BaseModal;
